<template>
<div class="pb-24 pt-2 pl-4 pr-4 text-lg">
  <vs-button @click="changeCurrentTariff"
             class="text-right hidden sm:block lg:block xl:block mb-4"
             color="primary" type="filled" >
    {{ $t('message.tariff.changeTariff') }}
  </vs-button>
  <div class="font-bold text-xl">{{$t('message.tariff.free')}}:</div>
  <div :key="option" v-for="option in upData[nextPlanCode]">
    <vs-icon icon="add" />
    {{$t(`message.tariff.option${option}.header`)}}
  </div>
  <div class="flex justify-between items-stretch my-8 max-w-xl flex-col md:flex-row">
    <vs-card class="mx-4 w-9/12">
      <div slot="header">
        <h5>{{$t('message.tariff.freeOptionPayHeader')}}</h5>
      </div>
      <div
        class="text-right text-lg mr-4 h-8 mt-4"
        v-html="$t('message.tariff.bigDiff', {
           next: nextPayments,
           now: maxPayments
         })"
      />
    </vs-card>
    <vs-card class="mx-4 w-9/12 ">
      <div slot="header">
        <h5>{{$t('message.tariff.minBalanceHeader')}}</h5>
      </div>
      <div
        class="text-right text-lg mr-4 h-8 mt-4"
         v-html="$t('message.tariff.bigDiff', {
           next: nextMinBalance,
           now: recommendMinBalance
         })"
      />
    </vs-card>
    <div class="mx-4 w-9/12 justify-between flex flex-col">
      <vs-card>
        <div class="mt-4 mb-0">
          <span class="text-left w-1/2 inline-block">{{$t('message.tariff.interestOnBalance')}}</span>
          <span class="text-right w-1/2 inline-block">
            {{$t('message.tariff.smallDiff', {
                next: interestNextBalance,
                now: interestOnBalance
            })}}
          </span>
        </div>
      </vs-card>
      <vs-card>
        <div class="mt-4 mb-0">
          <span class="text-left w-1/2 inline-block">{{$t('message.tariff.overnightOnBalance')}}</span>
          <span class="text-right w-1/2 inline-block">
            {{$t('message.tariff.smallDiff', {
              next: overnightNextBalance,
              now: overnightOnBalance
            })}}
          </span>
        </div>
      </vs-card>
    </div>
  </div>
  <div :key="data['id']" v-for="data in downData.main[nextPlanCode]">
    <vs-icon icon="done" />
    {{$t(`message.tariff.option${data['id']}.header`)}}
    <span v-if="notEmpty(data['val'])">:
      {{data['val']}}
    </span>
    <span v-if="data['trans']">:
      {{$t(`message.tariff.option${data['id']}.value.${data['trans']}`)}}
    </span>
  </div>
  <div class="mb-12" />
  <div :key="data['id']" v-for="data in downData.star[nextPlanCode]">
    {{$t(`message.tariff.option${data['id']}.star`)}}
    <span v-if="notEmpty(data['val'])">:
      {{data['val']}}
    </span>
    <span v-if="data['trans']">:
      {{$t(`message.tariff.option${data['id']}.starValue.${data['trans']}`)}}
    </span>
  </div>
</div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
import { isNil } from 'lodash'

export default {
  name: 'TariffUpdate',
  props: {
    upData: {

    },
    template: {

    },
    nextTariffInfo: {

    }
  },
  data: () => ({
  }),
  methods: {
    ...mapActions('utils', ['changeTariff']),
    notEmpty (val) {
      return !isNil(val)
    },
    async changeCurrentTariff () {
      this.changeTariff(this.nextTariffInfo['tarif_name'])
    }
  },
  computed: {
    ...mapGetters('utils', ['getTariffSpec', 'getTariffInfo', 'getTariffs']),
    curPayments () {
      return this.getTariffInfo['rtjs_limit']
    },
    maxPayments () {
      return this.getTariffSpec(this.getTariffInfo['tarif_code'])['rtjs_limit']
    },
    nextPayments () {
      return this.nextTariffInfo['rtjs_limit']
    },
    minBalance () {
      return parseFloat(this.getTariffInfo['balance_min']).toFixed(2)
    },
    recommendMinBalance () {
      return parseFloat(this.getTariffSpec(this.getTariffInfo['tarif_code'])['balance_min']).toFixed(2)
    },
    nextMinBalance () {
      return parseFloat(this.nextTariffInfo['balance_min']).toFixed(2)
    },
    interestOnBalance () {
      return parseFloat(this.getTariffSpec(this.getTariffInfo['tarif_code'])['balance_min_persent']).toFixed(2)
    },
    overnightOnBalance () {
      return parseFloat(this.getTariffSpec(this.getTariffInfo['tarif_code'])['overnight']).toFixed(2)
    },
    interestNextBalance () {
      return parseFloat(this.nextTariffInfo['balance_min_persent']).toFixed(2)
    },
    overnightNextBalance () {
      return parseFloat(this.nextTariffInfo['overnight']).toFixed(2)
    },
    currentPlanCode () {
      return this.getTariffInfo['tarif_code']
    },
    nextPlanCode () {
      return this.nextTariffInfo['tarif_code']
    },
    downData () {
      const data = {
        main: {},
        star: {}
      }
      const template = this.template
      const keys = ['main', 'star']

      const tariffsInfo = Object.values(this.getTariffs).reduce(function (carry, item) {
        return { ...carry, [item['tarif_code']]: { ...item }}
      }, {})

      keys.forEach(function (type) {
        Object.keys(template[type]).forEach(function (key) {
          if (Object.keys(data[type]).indexOf(key) === -1) {
            data[type][key] = []
          }

          template[type][key].forEach(function (item) {
            const calculatedItem = { ...item, val: null }
            if (item['valInt']) {
              calculatedItem['val'] = parseInt(tariffsInfo[key][item['valInt']], 10)
            }
            if (item['valStr']) {
              calculatedItem['val'] = tariffsInfo[key][item['valStr']] || 'Нет данных'
            }
            data[type][key].push(calculatedItem)
          })
        })
      })

      return data
    }
  }
}
</script>

<style scoped>

</style>
